import { useState } from 'react';
import logo from './images/onlylands.png';
import plains from './images/plains.jpg';
import island from './images/island.jpg';
import swamp from './images/swamp.jpg';
import mountain from './images/mountain.jpg';
import forest from './images/forest.jpg';
import plateau from './images/plateau.jpg';
import tropicalIsland from './images/tropical-island.jpg';
import raugrinTriome from './images/raugrin-triome.jpg';
import solRing from './images/sol-ring.jpg';
import './App.css';

const cards = [
  { 
    name: 'Plains', 
    image: plains, 
    handle: '@plains_daddy', 
    posts: 142, 
    likes: '12.4K', 
    fans: '8.2K',
    bio: '☀️ I\'ll tap for you anytime 💦 White mana only 🔥 DM for custom basic land content',
    status: '🟢 Online - tapping right now',
    tier: 'Top 5% of Lands'
  },
  { 
    name: 'Island', 
    image: island, 
    handle: '@wet_island', 
    posts: 98, 
    likes: '15.1K', 
    fans: '11.3K',
    bio: '💧 The wettest land on OnlyLands 🌊 Counter spell? More like counter SWELL 😏',
    status: '🟢 Online - making waves',
    tier: 'Top 3% of Lands'
  },
  { 
    name: 'Swamp', 
    image: swamp, 
    handle: '@swampy_cheeks', 
    posts: 203, 
    likes: '9.8K', 
    fans: '6.7K',
    bio: '💀 I like it dark and dirty 🖤 Will drain your life... and your wallet 😈 Goth energy',
    status: '🌙 Online late nights only',
    tier: 'Top 1% of Lands'
  },
  { 
    name: 'Mountain', 
    image: mountain, 
    handle: '@hot_mountain', 
    posts: 176, 
    likes: '18.2K', 
    fans: '14.1K',
    bio: '🔥 Warning: EXTREMELY hot content 🌋 I erupt on turn 1 ⚡ Lightning bolt in the DMs',
    status: '🟢 Online - feeling explosive',
    tier: 'Top 10% of Lands'
  },
  { 
    name: 'Forest', 
    image: forest, 
    handle: '@forest_bigmana', 
    posts: 221, 
    likes: '11.9K', 
    fans: '9.4K',
    bio: '🌲 The BIGGEST mana you\'ve ever seen 🍃 All natural, no mana dorks 💚 Ramp me',
    status: '🟢 Online - touching grass',
    tier: 'Top 2% of Lands'
  },
];

const premiumCards = [
  {
    name: 'Plateau',
    image: plateau,
    handle: '@plateau_duo',
    bio: '🏔️❤️🔥 Why pick one when you can have both? 😏 Double the mana, double the fun',
    tier: '🔥 Dual Land'
  },
  {
    name: 'Tropical Island',
    image: tropicalIsland,
    handle: '@tropical_couple',
    bio: '🏝️💧🌿 Two types at once... we don\'t judge 🌴 The OG power couple',
    tier: '🔥 Dual Land'
  },
  {
    name: 'Raugrin Triome',
    image: raugrinTriome,
    handle: '@raugrin_trio',
    bio: '🔥💧⚡ Looking for a third? We already found two 😈 3 colors, 1 wild night',
    tier: '👀 Triome'
  },
  {
    name: 'Sol Ring',
    image: solRing,
    handle: '@sol_ring_daddy',
    bio: '💍✨ I\'ll be whatever you want, babe 💕 Not a land but I tap like one 😘',
    tier: '💎 Artifact'
  },
];

const tipMenu = [
  { item: '👀 Peek at my art crop', price: 5 },
  { item: '🎴 Full art reveal', price: 15 },
  { item: '✨ Foil pics', price: 25 },
  { item: '🔥 Watch me tap (video)', price: 50 },
  { item: '💎 Borderless & Extended', price: 100 },
];

const searchEasterEggs = {
  'black lotus': { emoji: '🪷', message: "This creator charges $100,000/month. Your credit card just fainted.", type: 'expensive' },
  'lotus': { emoji: '🪷', message: "This creator charges $100,000/month. Your credit card just fainted.", type: 'expensive' },
  'mox': { emoji: '💎', message: "The Mox family doesn't do OnlyLands. They're too busy being on the Reserved List.", type: 'expensive' },
  'power nine': { emoji: '👑', message: "The Power Nine don't need OnlyLands. They have generational wealth.", type: 'expensive' },
  'power 9': { emoji: '👑', message: "The Power Nine don't need OnlyLands. They have generational wealth.", type: 'expensive' },
  'onlyfans': { emoji: '🙄', message: "Sir, this is OnlyLANDS. We tap for mana here.", type: 'wrong' },
  'only fans': { emoji: '🙄', message: "Sir, this is OnlyLANDS. We tap for mana here.", type: 'wrong' },
  'fetch': { emoji: '🔍', message: "Fetch lands are always searching... just like you at 2am 😏", type: 'flirty' },
  'shock': { emoji: '⚡', message: "Into pain, are we? 2 life to see this content 😈", type: 'flirty' },
  'basic': { emoji: '💅', message: "Excuse me?? Our basics are ANYTHING but basic, sweetie.", type: 'sassy' },
  'wastes': { emoji: '🆕', message: "Wastes just joined! Be gentle, it's their first colorless experience 🥺", type: 'new' },
  'tapped': { emoji: '😏', message: "Looking for tapped content? Oh you NAUGHTY planeswalker...", type: 'flirty' },
  'tap': { emoji: '😏', message: "Looking for tap content? Oh you NAUGHTY planeswalker...", type: 'flirty' },
  'untap': { emoji: '🔄', message: "Untap content is in our 'Morning After' collection 💤", type: 'flirty' },
  'sol ring': { emoji: '💍', message: "Sol Ring will be whatever you want, babe. Check Premium 😘", type: 'premium' },
  'commander': { emoji: '👨‍✈️', message: "Looking for someone to take command? 😏 100 cards, 1 wild night", type: 'flirty' },
  'banned': { emoji: '🚫', message: "Looking for banned content?? This isn't THAT kind of site... unless? 👀", type: 'sus' },
  'free': { emoji: '😂', message: "HAHAHAHA 'free' good one. This is a premium mana experience.", type: 'sassy' },
  'nude': { emoji: '🎴', message: "All our lands come FULLY ILLUSTRATED. How scandalous!", type: 'flirty' },
  'nudes': { emoji: '🎴', message: "All our lands come FULLY ILLUSTRATED. How scandalous!", type: 'flirty' },
  'foil': { emoji: '✨', message: "Foil content is EXTRA... just like you for searching this 💅", type: 'premium' },
  'full art': { emoji: '🖼️', message: "Full art? You want to see EVERYTHING, don't you? 😳", type: 'flirty' },
  'borderless': { emoji: '😱', message: "BORDERLESS?! No protection?? How risqué!", type: 'flirty' },
  'extended': { emoji: '📏', message: "Looking for EXTENDED content? We don't judge here 😏", type: 'flirty' },
  'urza': { emoji: '👴', message: "Urza's lands are vintage content. Must be 18+ and own a time machine.", type: 'old' },
  'eldrazi': { emoji: '👁️', message: "Eldrazi content is... tentacle stuff. Different site.", type: 'sus' },
  'dual land': { emoji: '👯', message: "Looking for couples content? Check our Premium duos 💕", type: 'premium' },
  'triome': { emoji: '👯‍♀️', message: "Triomes are in Premium. Three's company 😈", type: 'premium' },
  'mom': { emoji: '😰', message: "MOM?! CLOSE THE TAB! CLOSE THE TAB!", type: 'panic' },
  'dad': { emoji: '😰', message: "DAD?! I CAN EXPLAIN! IT'S JUST BASIC LANDS!", type: 'panic' },
  'wizards': { emoji: '🧙', message: "Wizards of the Coast lawyers have entered the chat... jk we're parody 😅", type: 'panic' },
  'hasbro': { emoji: '📈', message: "Hasbro: 'Write that down, write that down!'", type: 'corporate' },
  'expensive': { emoji: '💸', message: "Everything here is cheaper than a Modern deck, relax.", type: 'sassy' },
  'girlfriend': { emoji: '💔', message: "Bold of you to assume MTG players have those. Lands won't leave you.", type: 'sad' },
  'boyfriend': { emoji: '💔', message: "Bold of you to assume MTG players have those. Lands won't leave you.", type: 'sad' },
};

function App() {
  const [verified, setVerified] = useState(false);
  const [subscribed, setSubscribed] = useState({});
  const [showTipMenu, setShowTipMenu] = useState(null);
  const [showMobileSearch, setShowMobileSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [showSearchResults, setShowSearchResults] = useState(false);

  const toggleSubscribe = (name) => {
    setSubscribed(prev => ({ ...prev, [name]: !prev[name] }));
  };

  const totalSubs = Object.values(subscribed).filter(Boolean).length;

  const getSearchResult = () => {
    const query = searchQuery.toLowerCase().trim();
    if (!query) return null;
    
    // Check for easter eggs
    for (const [key, value] of Object.entries(searchEasterEggs)) {
      if (query.includes(key)) {
        return value;
      }
    }
    
    // Check if searching for one of our lands
    const matchedLand = [...cards, ...premiumCards].find(c => 
      c.name.toLowerCase().includes(query) || query.includes(c.name.toLowerCase())
    );
    if (matchedLand) {
      return { 
        emoji: '😍', 
        message: `${matchedLand.name} is available! ${matchedLand.handle} is waiting for you...`, 
        type: 'found',
        land: matchedLand
      };
    }
    
    // Default no results
    const noResults = [
      { emoji: '😢', message: "No lands found. They're probably tapped out right now." },
      { emoji: '🔍', message: "Can't find that... maybe try searching 'hot basics near me'?" },
      { emoji: '💔', message: "Nothing here. Even lands have standards, apparently." },
      { emoji: '🤷', message: "404: Land not found. Have you tried touching grass IRL?" },
      { emoji: '😅', message: "We don't have that... yet. DM us your land suggestions 👀" },
    ];
    return noResults[Math.floor(Math.random() * noResults.length)];
  };

  const searchResult = getSearchResult();

  if (!verified) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center px-4" style={{ background: 'linear-gradient(135deg, #faf6f0 0%, #f0e8dc 100%)' }}>
        <img src={logo} alt="OnlyLands" className="h-16 sm:h-24 mb-6 sm:mb-8" />
        <div className="bg-white rounded-xl p-6 sm:p-8 max-w-md text-center shadow-xl mx-4">
          <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-4">⚠️ Age Verification Required</h2>
          <p className="text-gray-600 mb-4 sm:mb-6 text-sm sm:text-base">
            This website contains <span className="text-blue-500 font-semibold">EXPLICIT BASIC LAND CONTENT</span> including but not limited to: full art lands, foils, and lands tapping for mana.
          </p>
          <p className="text-gray-500 text-xs sm:text-sm mb-4 sm:mb-6">
            By entering, you confirm you are 18+ and your mom won't find your MTG collection.
          </p>
          <div className="space-y-3">
            <button 
              onClick={() => setVerified(true)}
              className="w-full bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 rounded-full transition-colors text-sm sm:text-base"
            >
              I am 18+ (and own at least 50 basic lands)
            </button>
            <button 
              onClick={() => window.location.href = 'https://scryfall.com/search?q=artist%3Amagali&order=released'}
              className="w-full bg-gray-200 hover:bg-gray-300 text-gray-700 font-bold py-3 rounded-full transition-colors text-sm sm:text-base"
            >
              No, take me somewhere safe
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen text-gray-800" style={{ background: 'linear-gradient(135deg, #faf6f0 0%, #f0e8dc 100%)' }}>
      {/* Header */}
      <header className="sticky top-0 z-50 bg-white/90 backdrop-blur-sm border-b border-amber-200 shadow-sm">
        <div className="max-w-6xl mx-auto px-3 sm:px-4 py-2 sm:py-3 flex items-center justify-between">
          <img src={logo} alt="OnlyLands" className="h-6 sm:h-8" />
          
          <div className="flex items-center gap-2 sm:gap-4">
            {/* Desktop Search */}
            <div className="relative hidden md:block">
              <input 
                type="text" 
                placeholder="Search for lands..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onFocus={() => setShowSearchResults(true)}
                onBlur={() => setTimeout(() => setShowSearchResults(false), 200)}
                className="bg-amber-50 text-gray-800 text-sm rounded-full px-4 py-2 pl-10 w-64 focus:outline-none focus:ring-2 focus:ring-blue-500 border border-amber-200"
              />
              <svg className="w-4 h-4 text-gray-500 absolute left-3 top-1/2 -translate-y-1/2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
              
              {/* Desktop Search Results Dropdown */}
              {showSearchResults && searchQuery && searchResult && (
                <div className="absolute top-full mt-2 w-80 bg-white rounded-xl shadow-xl border border-amber-200 p-4 z-50 left-1/2 -translate-x-1/2">
                  <div className="text-center">
                    <span className="text-4xl mb-2 block">{searchResult.emoji}</span>
                    <p className="text-gray-700 text-sm">{searchResult.message}</p>
                    {searchResult.land && (
                      <div className="mt-3 p-2 bg-amber-50 rounded-lg">
                        <p className="text-xs text-gray-500">{searchResult.land.handle}</p>
                        <p className="text-xs text-green-500">{searchResult.land.status || '🟢 Online'}</p>
                      </div>
                    )}
                    {searchResult.type === 'premium' && (
                      <button className="mt-3 bg-gradient-to-r from-purple-500 to-pink-500 text-white text-xs px-4 py-2 rounded-full">
                        🔓 View Premium
                      </button>
                    )}
                    {searchResult.type === 'panic' && (
                      <button 
                        onClick={() => setSearchQuery('')}
                        className="mt-3 bg-red-500 text-white text-xs px-4 py-2 rounded-full animate-pulse"
                      >
                        🚨 CLEAR HISTORY 🚨
                      </button>
                    )}
                  </div>
                </div>
              )}
              
              {/* Trending Searches - shows when focused but no query */}
              {showSearchResults && !searchQuery && (
                <div className="absolute top-full mt-2 w-80 bg-white rounded-xl shadow-xl border border-amber-200 p-4 z-50 left-1/2 -translate-x-1/2">
                  <p className="text-xs text-gray-400 mb-2">🔥 Trending Searches</p>
                  <div className="flex flex-wrap gap-2">
                    {['full art', 'foil', 'tapped', 'dual land', 'borderless', 'extended'].map((term) => (
                      <button
                        key={term}
                        onMouseDown={() => setSearchQuery(term)}
                        className="text-xs bg-amber-100 hover:bg-amber-200 text-gray-700 px-3 py-1 rounded-full transition-colors"
                      >
                        {term}
                      </button>
                    ))}
                  </div>
                  <p className="text-xs text-gray-400 mt-3 mb-2">👀 Recently Viewed</p>
                  <div className="flex flex-wrap gap-2">
                    {['@wet_island', '@swampy_cheeks', '@hot_mountain'].map((handle) => (
                      <span key={handle} className="text-xs text-blue-500">
                        {handle}
                      </span>
                    ))}
                  </div>
                  <p className="text-xs text-pink-400 mt-3 italic">We won't tell anyone what you searched... 🤫</p>
                </div>
              )}
            </div>
            
            {/* Mobile Search Button */}
            <button 
              onClick={() => setShowMobileSearch(!showMobileSearch)}
              className="md:hidden w-9 h-9 bg-amber-100 rounded-full flex items-center justify-center border border-amber-200"
            >
              <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </button>
            
            <button className="bg-blue-500 hover:bg-blue-600 text-white text-xs sm:text-sm font-semibold px-3 sm:px-4 py-1.5 sm:py-2 rounded-full transition-colors">
              💎 {totalSubs} Subs
            </button>
            
            <div className="w-8 h-8 sm:w-9 sm:h-9 bg-amber-100 rounded-full flex items-center justify-center border border-amber-200">
              <span className="text-xs sm:text-sm">🧙</span>
            </div>
          </div>
        </div>
        
        {/* Mobile Search Dropdown */}
        {showMobileSearch && (
          <div className="md:hidden px-3 pb-3">
            <input 
              type="text" 
              placeholder="Search for lands..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full bg-amber-50 text-gray-800 text-sm rounded-full px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 border border-amber-200"
            />
            {/* Mobile Search Results */}
            {searchQuery && searchResult && (
              <div className="mt-2 bg-white rounded-xl shadow-lg border border-amber-200 p-4">
                <div className="text-center">
                  <span className="text-3xl mb-2 block">{searchResult.emoji}</span>
                  <p className="text-gray-700 text-sm">{searchResult.message}</p>
                  {searchResult.land && (
                    <div className="mt-3 p-2 bg-amber-50 rounded-lg">
                      <p className="text-xs text-gray-500">{searchResult.land.handle}</p>
                      <p className="text-xs text-green-500">{searchResult.land.status || '🟢 Online'}</p>
                    </div>
                  )}
                  {searchResult.type === 'premium' && (
                    <button className="mt-3 bg-gradient-to-r from-purple-500 to-pink-500 text-white text-xs px-4 py-2 rounded-full">
                      🔓 View Premium
                    </button>
                  )}
                  {searchResult.type === 'panic' && (
                    <button 
                      onClick={() => setSearchQuery('')}
                      className="mt-3 bg-red-500 text-white text-xs px-4 py-2 rounded-full animate-pulse"
                    >
                      🚨 CLEAR HISTORY 🚨
                    </button>
                  )}
                </div>
              </div>
            )}
            {/* Mobile Trending Searches */}
            {!searchQuery && (
              <div className="mt-2 bg-white rounded-xl shadow-lg border border-amber-200 p-4">
                <p className="text-xs text-gray-400 mb-2">🔥 Trending Searches</p>
                <div className="flex flex-wrap gap-2">
                  {['full art', 'foil', 'tapped', 'dual land'].map((term) => (
                    <button
                      key={term}
                      onClick={() => setSearchQuery(term)}
                      className="text-xs bg-amber-100 hover:bg-amber-200 text-gray-700 px-3 py-1 rounded-full transition-colors"
                    >
                      {term}
                    </button>
                  ))}
                </div>
                <p className="text-xs text-pink-400 mt-3 italic">We won't tell anyone... 🤫</p>
              </div>
            )}
          </div>
        )}
      </header>

      {/* Scrolling Banner */}
      <div className="bg-gradient-to-r from-pink-500 via-purple-500 to-blue-500 py-2 overflow-hidden">
        <div className="animate-pulse text-center text-white text-xs sm:text-sm font-semibold px-4">
          <p>🔥 NEW: Wastes just joined! First non-basic on OnlyLands!</p>
          <p>Use code MANA20 for 20% off 🔥</p>
        </div>
      </div>

      {/* Main Content */}
      <main className="max-w-6xl mx-auto py-6 sm:py-8 px-3 sm:px-4">
        <div className="mb-6 sm:mb-8">
          <h1 className="text-xl sm:text-2xl font-bold mb-2 text-gray-800">🔥 Hot Lands Near You</h1>
          <p className="text-gray-500 text-sm sm:text-base">These basics are ready to tap</p>
        </div>
        
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 sm:gap-4">
          {cards.map((card) => (
            <div 
              key={card.name}
              className="bg-white rounded-lg overflow-hidden hover:shadow-lg transition-all shadow-md relative flex flex-col"
            >
              <div className="absolute top-1 sm:top-2 left-1 sm:left-2 z-10 bg-gradient-to-r from-yellow-500 to-orange-500 text-white text-xs px-1.5 sm:px-2 py-0.5 sm:py-1 rounded-full font-bold" style={{ fontSize: '10px' }}>
                {card.tier}
              </div>
              
              <div className="relative">
                <img 
                  src={card.image} 
                  alt={card.name}
                  className="w-full h-auto"
                />
                {subscribed[card.name] && (
                  <div className="absolute top-1 sm:top-2 right-1 sm:right-2 bg-blue-500 text-white px-1.5 sm:px-2 py-0.5 sm:py-1 rounded-full" style={{ fontSize: '10px' }}>
                    ✓ VIP
                  </div>
                )}
              </div>
              
              <div className="p-2 sm:p-4 flex flex-col flex-grow">
                <div className="flex items-center gap-1 sm:gap-2 mb-0.5 sm:mb-1">
                  <h3 className="font-bold text-gray-800 text-sm sm:text-base">{card.name}</h3>
                  <svg className="w-3 h-3 sm:w-4 sm:h-4 text-blue-500" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                </div>
                <p className="text-gray-500 text-xs sm:text-sm">{card.handle}</p>
                <p className="text-green-400 mt-0.5 sm:mt-1" style={{ fontSize: '10px' }}>{card.status}</p>
                
                <p className="text-gray-600 text-xs mt-2 leading-relaxed">{card.bio}</p>
                
                <div className="flex gap-2 sm:gap-3 text-gray-400 mt-2 sm:mt-3 mb-2 sm:mb-4" style={{ fontSize: '10px' }}>
                  <span>📸 {card.posts}</span>
                  <span>❤️ {card.likes}</span>
                  <span>👥 {card.fans}</span>
                </div>
                
                <div className="space-y-1.5 sm:space-y-2 mt-auto">
                  <button
                    onClick={() => toggleSubscribe(card.name)}
                    className={`w-full py-1.5 sm:py-2 rounded-full font-semibold text-xs sm:text-sm transition-all ${
                      subscribed[card.name] 
                        ? 'bg-gray-200 text-gray-700 hover:bg-gray-300' 
                        : 'bg-blue-500 text-white hover:bg-blue-600'
                    }`}
                  >
                    {subscribed[card.name] ? '✓ Subscribed' : '🔓 $5/mo'}
                  </button>
                  <button
                    onClick={() => setShowTipMenu(showTipMenu === card.name ? null : card.name)}
                    className="w-full py-1.5 sm:py-2 rounded-full font-semibold text-xs sm:text-sm bg-pink-500 hover:bg-pink-600 text-white transition-all"
                  >
                    💸 Tip
                  </button>
                </div>
                
                {showTipMenu === card.name && (
                  <div className="mt-2 sm:mt-3 bg-amber-50 rounded-lg p-2 sm:p-3 text-xs sm:text-sm border border-amber-200">
                    <p className="text-pink-500 font-bold mb-1 sm:mb-2">💕 {card.name}'s Tips:</p>
                    {tipMenu.map((tip, i) => (
                      <div key={i} className="flex justify-between text-gray-600 py-0.5 sm:py-1 border-b border-amber-200 last:border-0">
                        <span className="truncate mr-2">{tip.item}</span>
                        <span className="text-green-600 font-semibold">${tip.price}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
        
        {/* Premium Content Section */}
        <div className="mt-8 sm:mt-12">
          <h2 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4 text-gray-800">🔒 Premium Content (Subscribe to Unlock)</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4">
            {premiumCards.map((card) => (
              <div key={card.name} className="bg-white rounded-lg overflow-hidden shadow-md relative">
                {/* Tier Badge */}
                <div className="absolute top-1 sm:top-2 left-1 sm:left-2 z-20 bg-gradient-to-r from-purple-500 to-pink-500 text-white text-xs px-1.5 sm:px-2 py-0.5 sm:py-1 rounded-full font-bold" style={{ fontSize: '10px' }}>
                  {card.tier}
                </div>
                
                {/* Blurred Card Image */}
                <div className="relative">
                  <img 
                    src={card.image} 
                    alt={card.name}
                    className="w-full h-auto blur-lg"
                  />
                  {/* Lock Overlay */}
                  <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
                    <div className="text-center">
                      <span className="text-3xl sm:text-4xl">🔒</span>
                      <p className="text-white text-xs mt-1 font-semibold">VIP Only</p>
                    </div>
                  </div>
                </div>
                
                {/* Card Info */}
                <div className="p-2 sm:p-3">
                  <div className="flex items-center gap-1 mb-0.5">
                    <h3 className="font-bold text-gray-800 text-sm">{card.name}</h3>
                    <svg className="w-3 h-3 text-purple-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <p className="text-gray-400 text-xs">{card.handle}</p>
                  <p className="text-gray-600 text-xs mt-1 leading-relaxed">{card.bio}</p>
                  <button className="w-full mt-2 py-1.5 rounded-full font-semibold text-xs bg-gradient-to-r from-purple-500 to-pink-500 text-white hover:from-purple-600 hover:to-pink-600 transition-all">
                    🔓 Unlock $15/mo
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Testimonials */}
        <div className="mt-8 sm:mt-12 bg-white rounded-xl p-4 sm:p-6 shadow-md">
          <h2 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4 text-gray-800">💬 What Planeswalkers Are Saying</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 sm:gap-4">
            <div className="bg-amber-50 p-3 sm:p-4 rounded-lg border border-amber-200">
              <p className="text-gray-600 text-xs sm:text-sm italic">"I've never seen a Plains tap like that before. Life-changing content."</p>
              <p className="text-gray-400 text-xs mt-2">- JaceBeleren420</p>
            </div>
            <div className="bg-amber-50 p-3 sm:p-4 rounded-lg border border-amber-200">
              <p className="text-gray-600 text-xs sm:text-sm italic">"The Swamp content is so dark and mysterious. Worth every penny."</p>
              <p className="text-gray-400 text-xs mt-2">- LilianaSimp99</p>
            </div>
            <div className="bg-amber-50 p-3 sm:p-4 rounded-lg border border-amber-200">
              <p className="text-gray-600 text-xs sm:text-sm italic">"Finally a place where lands get the respect they deserve. 10/10"</p>
              <p className="text-gray-400 text-xs mt-2">- NissaStanAccount</p>
            </div>
          </div>
        </div>
        
        {/* Promo Banner */}
        <div className="mt-8 sm:mt-12 bg-gradient-to-r from-pink-600 via-purple-600 to-blue-600 rounded-xl p-5 sm:p-8 text-center">
          <h2 className="text-lg sm:text-2xl font-bold text-white mb-2">🎉 ULTIMATE MANA BUNDLE 🎉</h2>
          <p className="text-purple-100 mb-2 text-sm sm:text-base">All 5 lands. One price. Unlimited tapping.</p>
          <p className="text-yellow-300 text-xs sm:text-sm mb-3 sm:mb-4">⚡ Includes: Exclusive foil content, tap videos, and a signed playmat pic</p>
          <button className="bg-white text-purple-600 font-bold px-6 sm:px-8 py-2 sm:py-3 rounded-full hover:bg-gray-100 transition-colors text-sm sm:text-base">
            Get All Access for $20/mo 💳
          </button>
          <p className="text-purple-200 text-xs mt-2 sm:mt-3">Cancel anytime. Your LGS owner won't judge you.</p>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-amber-200 mt-8 sm:mt-12 py-4 sm:py-6 text-center text-gray-500 text-xs sm:text-sm px-4">
        <p>© 2025 OnlyLands™ - "Where Basics Get Tapped"</p>
        <p className="mt-1 text-gray-400">Not affiliated with OnlyFans, Wizards of the Coast, or your disappointed parents.</p>
        <div className="mt-2 sm:mt-3 flex flex-wrap justify-center gap-2 sm:gap-4 text-xs text-gray-400">
          <span>Privacy Policy</span>
          <span>|</span>
          <span>Terms of Tapping</span>
          <span>|</span>
          <span>DMCA (Don't Mess with Card Art)</span>
        </div>
      </footer>
    </div>
  );
}

export default App;
